"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomAction = exports.StaticWappName = exports.WappMode = exports.Exceptions = void 0;
var Exceptions;
(function (Exceptions) {
    Exceptions["INVALID"] = "INVALID";
    Exceptions["NOT_FOUND"] = "NOT_FOUND";
    Exceptions["NOT_ALLOWED"] = "NOT_ALLOWED";
    Exceptions["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    Exceptions["TEMPORARILY_NOT_AVAILABLE"] = "TEMPORARILY_NOT_AVAILABLE";
    Exceptions["CANCELED"] = "CANCELED";
    Exceptions["FAILED"] = "FAILED";
})(Exceptions = exports.Exceptions || (exports.Exceptions = {}));
var WappMode;
(function (WappMode) {
    WappMode["INLINE"] = "inline";
    WappMode["MAIN"] = "main";
    WappMode["OVERLAY"] = "overlay";
    WappMode["STATIC"] = "static";
})(WappMode = exports.WappMode || (exports.WappMode = {}));
var StaticWappName;
(function (StaticWappName) {
    StaticWappName["KOOLEH"] = "KOOLEH";
    StaticWappName["JARYAN"] = "JARYAN";
    StaticWappName["MAVAKEB"] = "MAVAKEB";
    StaticWappName["RAHKAR"] = "RAHKAR";
})(StaticWappName = exports.StaticWappName || (exports.StaticWappName = {}));
var CustomAction;
(function (CustomAction) {
    CustomAction["EDIT"] = "EDIT";
    CustomAction["SHARE"] = "SHARE";
    CustomAction["DELETE"] = "DELETE";
})(CustomAction = exports.CustomAction || (exports.CustomAction = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3R5cGVzL2NvbW1vbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFJQSxJQUFZLFVBUVg7QUFSRCxXQUFZLFVBQVU7SUFDcEIsaUNBQW1CLENBQUE7SUFDbkIscUNBQXVCLENBQUE7SUFDdkIseUNBQTJCLENBQUE7SUFDM0IsNkNBQStCLENBQUE7SUFDL0IscUVBQXVELENBQUE7SUFDdkQsbUNBQXFCLENBQUE7SUFDckIsK0JBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQVJXLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBUXJCO0FBSUQsSUFBWSxRQUtYO0FBTEQsV0FBWSxRQUFRO0lBQ2xCLDZCQUFpQixDQUFBO0lBQ2pCLHlCQUFhLENBQUE7SUFDYiwrQkFBbUIsQ0FBQTtJQUNuQiw2QkFBaUIsQ0FBQTtBQUNuQixDQUFDLEVBTFcsUUFBUSxHQUFSLGdCQUFRLEtBQVIsZ0JBQVEsUUFLbkI7QUFFRCxJQUFZLGNBS1g7QUFMRCxXQUFZLGNBQWM7SUFDeEIsbUNBQWlCLENBQUE7SUFDakIsbUNBQWlCLENBQUE7SUFDakIscUNBQW1CLENBQUE7SUFDbkIsbUNBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUxXLGNBQWMsR0FBZCxzQkFBYyxLQUFkLHNCQUFjLFFBS3pCO0FBT0QsSUFBWSxZQUlYO0FBSkQsV0FBWSxZQUFZO0lBQ3RCLDZCQUFhLENBQUE7SUFDYiwrQkFBZSxDQUFBO0lBQ2YsaUNBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUpXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBSXZCIn0=